<template>
  <div class="i-table clearfix">
    <Spin size="large" fix v-if="spinShow">
      <slot>
        <div>
          <Icon type="ios-loading" size=40 class="demo-spin-icon-load"></Icon>
          <div>数据加载中</div>
        </div>
      </slot>
    </Spin>
    <Row class="i-table-top-btns">
      <i-button v-for="btn of actions.def" :type="btn.type" @click="btn.handler" :icon="btn.icon">{{btn.name}}
      </i-button>
    </Row>
    <Row class="i-table-title" v-if="prop.title" style="text-align:left">
      <h3>{{prop.title}}</h3>
    </Row>
    <i-table ref="elTable" :data="tableData" :show-header="!prop.notShowHeader?true:false" :height="tableHeight"
             :columns="prop.columns"  :row-class-name="rowClassName"  @on-selection-change="handleSelect" @on-sort-change="handleSortChange"
             @on-current-change="handleCurrentRowChange" @on-row-click="handleRowClick"  highlight-row stripe>
    </i-table>
    <Page v-if="!prop.noPage" @on-page-size-change="handleSizeChange" @on-change="handleCurrentPageChange"
          :page-size-opts="pagination.pageSizes" :page-size="pagination.pageSize" :total="pagination.total"
          :current="pagination.currentPage" :show-total="pagination.showTotal" :show-sizer="pagination.showSizer">
    </Page>
    <Modal class="modal" @on-cancel="cancel" :width="prop.formWidth||formInfo.width" :title="formInfo.title"
           v-model="dialogVisible" ref="dialog" :mask-closable="false">
      <slot name="form" :obj="formInfo.model" :action="formInfo.action" :tableVm="csTableVm" :tableInfo="prop"></slot>
      <div slot="footer">
       <!-- <Row class="footer-btns">
          <Button type="info" @click="submit" v-if="formInfo.action!='view'">确定</Button>
          <Button @click="cancel">取消</Button>
        </Row>-->
      </div>
    </Modal>
  </div>
</template>

<script>
  import CsDynamicTableMixins from './CsDynamicTableMixins'

  require('lodash'); //引用函数库lodash来做深copy
  export default {
    name: "CsDynamicTable",
    mixins: [CsDynamicTableMixins],
    props: ["prop"],
    data() {
      return {
      	timer:null,
        self: this,
        tableHeight:null,
        tableData: [
        ],
        actions: {},
        csTableVm: this,
        multipleSelection: [],
        currentRow: null,
        pageTimeout:null,//防止用户切换当前页面过快
        pagination: {
          pageSize: this.prop.pageInfo ? this.prop.pageInfo.pageSize : 10,
          total: 0,
          pageSizes: this.prop.pageInfo ? this.prop.pageInfo.pageSizes : [10, 20, 50, 100],
          currentPage: 1,
          order: this.prop.order||"",
          showTotal: true,
          showSizer: true
        },
        formInfo: Object.assign({
          title: "",
          size: "full",
          action: "save",
          width: 75,
          model: this.prop.emptyModel,
        }),
        dialogVisible: false,
      }
    },
    methods: {
      cancel() {
        this.$refs.dialog.$children[1].cancel()
      },
      submit() {
        let children = this.$refs.dialog.$children.filter((item) => {
          return jq(item.$el).find(".ivu-form").length>0;
        })
        children[0].submit()
      },
       initWindowEvent(){
      	window.addEventListener('resize', ()=> {
					this.calculateTableHeight()
				})
      },
      calculateTableHeight(){
      	let height=jq(".body").height()-jq(".i-table-top-btns").height()-70;
        if(jq(".ivu-page").length>0){
            let heightPage= jq(".ivu-page").height();
            height = height-heightPage;

        }     
        if(jq("[class$='-search']").length>0){
          let searchNum = jq("[class$='-search']").length;
          let height4=jq("[class$='-search']").height();
          height-=height4;
	    	}
        if(jq(".echarts-item").length>0){
          let height5=jq(".echarts-item").height();
          height=height-height5;
        }
        if(jq(".tabs-box").length>0){
          height=height-30
        }
        if(jq(".item-list").length>0){
          let height7 = jq(".item-list").height();
          height = height-height7;
        }
	    	if(jq(".i-table-title").length>0){
	    		height=height-jq(".i-table-title").height()
          let height6=jq(".echarts-item").height();
	    	}
				this.tableHeight=height;
      },
      rowClassName(row,index){
        if(this.prop.highlightValue){
          let key = this.prop.highlightColumn;
          if(row[key] == this.prop.highlightValue){
            return "ws-highlight-row"
          }else{
           return ""
          }
        }
        
      }

    },
    mounted(){
    	this.initWindowEvent();
    	this.calculateTableHeight()
		},
    filters: {}
  }
</script>




// WEBPACK FOOTER //
// src/components/dynamicTable/CsDynamicTable.vue